import { getChartLabel } from "./chartLabel";
import { useState } from "react";
import { Form } from "react-bootstrap";
import {
  ResponsiveContainer,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  BarChart,
  Bar,
  LabelList,
  Cell,
} from "recharts";
import CustomLegend from "./CustomLegend";
import CustomTooltipCat from "./CustomTooltipCat";
import CustomTooltip from "./CustomTooltip";
import CustomTooltipCrg from "./CustomTooltipCrg";

//kpi-15
const CRG = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }
  const crgData = data.map((item) => {
    return {
      place: item.Place,
      crg: item.district_crg_constituted,
      report: Number(item.Reported_during_the_month),
      cumulative: Number(item.cumulative_fy),
      date: item.date_of_notification,
    };
  });

  const severityOrder = {
    No: 1,
    Yes: 2,
  };

  const inverseSeverity = Object.entries(severityOrder).reduce(
    (acc, [k, v]) => {
      acc[v] = k;
      return acc;
    },
    {},
  );
  const chartData = data.map((item) => {
    return {
      place: item.Place,
      crg: severityOrder[item.district_crg_constituted],
    };
  });
  const totalPages = Math.ceil(crgData.length / itemsPerPage);

  const currentData = crgData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const getPageNumbers = () => {
    const pageNumbers = [];
    const delta = 2;

    const range = [];
    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      pageNumbers.push("...");
    }

    pageNumbers.push(...range);

    if (currentPage + delta < totalPages - 1) {
      pageNumbers.push("...");
    }

    return [1, ...pageNumbers, totalPages];
  };

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle">
              <h5 style={{ fontWeight: "bold" }}>
                {" "}
                CRG Constituted {getChartLabel(filters, selectedState)}
              </h5>
            </div>
            {/* <div class="cardDropDown gap-3">
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div> */}
          </div>
        </div>
      </div>

      <div className="card hptCard mt-4 border-0">
        <div className="table-responsive">
          <table className="table table-bordered ">
            <thead className="thead-light">
              <tr>
                <th className="fw-bold">Place</th>
                <th className="text-center fw-bold">
                  District CRG Constituted
                </th>
                <th className="text-center fw-bold">Report</th>
                <th className="text-center fw-bold">Cumulative</th>
                <th className="text-center fw-bold">Date of notification</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, idx) => (
                <tr key={idx}>
                  <td style={{ fontWeight: "bold" }}>{item.place}</td>
                  <td>{item.crg}</td>
                  <td>{item.report}</td>
                  <td>{item.cumulative}</td>
                  <td>{item.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {totalPages > 1 && (
          <div className="card-footer">
            <div className="d-flex justify-content-center mt-3">
              <nav>
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    >
                      &laquo;
                    </button>
                  </li>

                  {getPageNumbers().map((page, index) => (
                    <li
                      key={index}
                      className={`page-item ${
                        page === currentPage ? "active" : ""
                      } ${page === "..." ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          typeof page === "number" && setCurrentPage(page)
                        }
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((p) => Math.min(p + 1, totalPages))
                      }
                    >
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        )}
      </div>

      {/* {showTable ? (
        <div className="card hptCard mt-4 border-0">
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead className="thead-light">
                <tr>
                  <th className="fw-bold">Place</th>
                  <th className="text-center fw-bold">
                    District CRG Constituted
                  </th>
                  <th className="text-center fw-bold">Report</th>
                  <th className="text-center fw-bold">Cumulative</th>
                  <th className="text-center fw-bold">Date of notification</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((item, idx) => (
                  <tr key={idx}>
                    <td style={{ fontWeight: "bold" }}>{item.place}</td>
                    <td>{item.crg}</td>
                    <td>{item.report}</td>
                    <td>{item.cumulative}</td>
                    <td>{item.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && (
            <div className="card-footer">
              <div className="d-flex justify-content-center mt-3">
                <nav>
                  <ul className="pagination">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage((p) => Math.max(p - 1, 1))
                        }
                      >
                        &laquo;
                      </button>
                    </li>

                    {getPageNumbers().map((page, index) => (
                      <li
                        key={index}
                        className={`page-item ${
                          page === currentPage ? "active" : ""
                        } ${page === "..." ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            typeof page === "number" && setCurrentPage(page)
                          }
                          disabled={page === "..."}
                        >
                          {page}
                        </button>
                      </li>
                    ))}

                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage((p) => Math.min(p + 1, totalPages))
                        }
                      >
                        &raquo;
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="card hptCard mt-4 border-0">
          <div className="card-body">
            <h6
              style={{
                fontWeight: "bold",
              }}
            >
              District CRG Constituted
            </h6>
          </div>
          <ResponsiveContainer width="100%" height={500}>
            <BarChart
              width={500}
              height={500}
              data={chartData}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 130,
              }}
            >
              <XAxis
                dataKey="place"
                angle={-90}
                textAnchor="end"
                interval={0}
                label={{
                  value: "",
                  position: "insideBottom",
                  offset: -110,
                  color: "#ca8282ff",
                  fontWeight: "bold",
                }}
              />
              <YAxis
                yAxisId="left"
                orientation="left"
                //stroke="#8884d8"
                label={{
                  value: "",
                  angle: -90,
                  position: "outside",
                  offset: -100,
                }}
              />
              <Tooltip content={<CustomTooltipCrg />} />
              <Legend
                verticalAlign="top"
                content={<CustomLegend order={["crg"]} />}
              />

              <Bar
                yAxisId="left"
                dataKey="crg"
                fill="#dd1e47"
                name="District CRG Constituted"
              >
                <LabelList
                  dataKey="crg"
                  position="top"
                  content={({ x, y, width, value }) => {
                    if (!value) return null;
                    return (
                      <text
                        x={x + width / 2} // horizontal center
                        y={y - 5} // vertical center
                        // white text (change if needed)

                        fontSize={12}
                        fontWeight="bold"
                        textAnchor="middle"
                        dominantBaseline="middle"
                      >
                        {inverseSeverity[value]}
                      </text>
                    );
                  }}
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )} */}
    </div>
  );
};
export default CRG;
